import { Component, OnInit } from "@angular/core";
import Chart from "chart.js";
import { CommonApiService } from "src/app/services/common-api.service";
import { first } from "rxjs/operators";
import * as _ from "lodash";
import * as moment from "moment";
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

declare var $: any;

// var _ = require('lodash');

@Component({
  selector: "app-analysis",
  templateUrl: "./analysis.component.html",
  styleUrls: ["./analysis.component.scss"],
})
export class AnalysisComponent implements OnInit {
  public datasets: any;
  public data: any;
  public stackdata: any;
  public uptimePercentage: any;
  public clicked: boolean = true;
  public clicked1: boolean = false;
  public clicked2: boolean = false;
  public meter: any;
  stackChart: any;
  selected_meter_id: any;
  page: Number = 0;
  count: Number = 6;
  applianceUsage: any;
  startTime: any;
  appliance: any;
  question_id: any;
  dashboard_id: any;
  output: any;
  answered: any;
  loader: boolean = false;

  constructor(public commonApi: CommonApiService, public router: Router) {
    this.dashboard_id = this.router.getCurrentNavigation().extras.state;
  }

  ngOnInit(): void {
    this.loader = true;

    this.selected_meter_id = localStorage.getItem("selected_meter");
    this.getYesterday();

    this.getApplianceUsageLog();

  }

  getYesterday() {
    this.commonApi.getYesterdayBreakdown().pipe(first()).subscribe((res) => {
      this.loader = false;
      this.data = res["devices"];
      this.stackdata = res["devices"];
      this.data = _.slice(res["devices"], 0, 3);
    });
    var endDate = moment().startOf('day').toISOString(); //the current time
    var startDate = moment().subtract(1, 'day').startOf('day').toISOString()

    this.commonApi.getUpTime(startDate, endDate).pipe(first()).subscribe(res => {
      this.uptimePercentage = res['uptimePercent']
      console.log(this.uptimePercentage, "Day");
    })
  }
  getLast7days() {
    this.commonApi.getLast7DaysBreakdown().pipe(first()).subscribe((res) => {
      this.loader = false;
      this.data = res["devices"];
      this.stackdata = res["devices"];
      this.data = _.slice(res["devices"], 0, 3);
    });
    var endDate = moment().startOf('day').toISOString(); //the current time
    var startDate = moment().subtract(7, 'day').startOf('day').toISOString()

    this.commonApi.getUpTime(startDate, endDate).pipe(first()).subscribe(res => {
      this.uptimePercentage = res['uptimePercent']
      console.log(this.uptimePercentage, "Week");
    })
  }
  getLast30days() {
    this.commonApi.getLast30DaysBreakdown().pipe(first()).subscribe((res) => {
      this.loader = false;
      this.data = res["devices"];
      this.stackdata = res["devices"];
      this.data = _.slice(res["devices"], 0, 3);
    });
    var endDate = moment().startOf('day').toISOString(); //the current time
    var startDate = moment().subtract(30, 'day').startOf('day').toISOString()

    this.commonApi.getUpTime(startDate, endDate).pipe(first()).subscribe(res => {
      this.uptimePercentage = res['uptimePercent']
      console.log(this.uptimePercentage, "Month");
      
    })
  }

  getApplianceList() {
    this.commonApi.getAppliance().pipe(first()).subscribe(res => {
      this.loader = false;
      this.appliance = res;

    })
  }

  getApplianceUsageLog() {
    this.commonApi.getApplianceUsageLogs(this.page, this.count).pipe(first()).subscribe((res) => {
      this.loader = false;
      this.applianceUsage = res;
    });
  }
  wrongDetection(question_id) {
    this.commonApi.verifyApplianceUsageWrong(question_id, "no").pipe(first()).subscribe(res => {
      this.output = res
      this.answered = res['answered']
      this.getApplianceUsageLog();

      Swal.fire({
        text: "Your response has been recorded",
        icon: 'success',
        confirmButtonColor: '#ef3f64'
      })
      // this.getApplianceUsageLog();

    })
  }

  noThanks(question_id) {
    this.getApplianceUsageLog();
    Swal.fire({
      text: "Your response has been recorded",
      icon: 'success',
      confirmButtonColor: '#ef3f64'
    })
    // this.getApplianceUsageLog();
  }

  tagAppliance(question_id) {
    this.question_id = question_id;
    this.getApplianceList();
  }

  tagComplete(appliance_id) {
    this.commonApi.verifyApplianceAnalysis(this.question_id, "yes", appliance_id).pipe(first()).subscribe(res => {
      this.loader = false;
      this.getApplianceUsageLog();
      setTimeout(function () {
        Swal.fire({
          icon: 'success',
          title: 'Oops...',
          confirmButtonColor: '#ef3f64'
        })

      }, 1000)

    })

  }
}
